// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app"; // Firebase web SDK
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics, logEvent } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDjMTJ6tQ17bcX6oqsZjzUXz7RY1P9Vo_o",
  authDomain: "vbdesigns-d2a17.firebaseapp.com",
  projectId: "vbdesigns-d2a17",
  storageBucket: "vbdesigns-d2a17.appspot.com",
  messagingSenderId: "640768634436",
  appId: "1:640768634436:web:7be86e2ec3b2e789c05611",
  measurementId: "G-X57HGL7ERZ"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const imageStorage = getStorage(app);

// Send reports about wallpapers downloaded
export const firebaseAnalyticsEvent = (eventName: any, eventType: any, data: any) => {

  logEvent(analytics, eventName, {
    event_type: eventType,
    content_data: data,
  });
  console.log('report sent');
}
